import type { ResetPasswordDto } from '@nestjs-boilerplate/types';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';

import { resetPassword } from '../api/auth.api';

export function useResetPassword() {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (data: ResetPasswordDto) => resetPassword(data),
    onSuccess: (response) => {
      toast.success(response.message);
      navigate({ to: '/login' });
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to reset password. Please try again.');
    },
  });
}
